import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Card, Button, FloatingLabel, Form, Stack, Modal, Figure, InputGroup, Alert } from 'react-bootstrap';
import RegBreadcrumb from '../components/RegBreadcrumb';

import { shopService } from '../functions/shopApi';
import { authService } from '../functions/authenticate';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faPersonDress, faPerson } from "@fortawesome/free-solid-svg-icons";

import '../scss/RegisterMember.scss';
import '../scss/RegChart.scss';
import '../scss/Shop.scss';
import { set } from 'date-fns';

// const Shop = ({ itemList, setItemList, selectedList, setSelectedList, total, setTotal, setUserID, setUserName, login, setLogin, authToken, setAuthToken, deliveryFee }) => {
const Shop = ({ selectedList, setSelectedList, total, setTotal, setUserID, setUserName, login, setLogin, authToken, setAuthToken, deliveryFee }) => {

    let today = new Date();
    const [date, setDate] = useState(today.toDateString());
    let sizeList = ['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
    let [itemList, setItemList] = useState([]);
    const navigate = useNavigate();
    const [showSize, setShowSize] = useState(true);

    /****************** variable used in Modal *****************************/
    const [modalShow, setModalShow] = useState(false);
    const [fullscreen, setFullscreen] = useState('md-down');
    const [editItem, setEditItem] = useState(0);
    const [modalEdit, setModalEdit] = useState(false); // indicator that show whether the modal is used for add or edit item 
    const [modalErrorMessage, setModalErrorMessage] = useState('');
    const [image1, setImage1] = useState(''); // image view 1
    const [image2, setImage2] = useState(''); // image view 2
    const [imageView, setImageView] = useState(''); // selected image view
    const [imageBoxActive, setImageBoxActive] = useState(true);
    const [promo, setPromo] = useState('');
    const [selectedQuantity, setSelectedQuantity] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');

    const [merchandiseCollection, setMerchandiseCollection] = useState('Self Collect');
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [deliveryPostcode, setDeliveryPostcode] = useState('');
    const [deliveryCity, setDeliveryCity] = useState('');
    const [deliveryState, setDeliveryState] = useState('');
    const [deliveryCountry, setDeliveryCountry] = useState('Malaysia');


    // update the item image in modal whenever view is changed
    useEffect(() => {
        imageBoxActive ? setImageView(image1) : setImageView(image2);
    }, [imageBoxActive]);


    const [selectedItem, setSelectedItem] = useState(0);
    const [itemID, setItemID] = useState('');
    const [gender, setGender] = useState('');
    const [size, setSize] = useState('');
    const [sizeBtnType, setSizeBtnType] = useState(['disabled', '', '', '', '', '', '']);
    const [quantity, setQuantity] = useState(1);
    const [merchandiseType, setMerchandiseType] = useState(0);
    const handleQuantity = (e) => {
        let qty = e.target.value;
        setQuantity(qty);
    }
    const clickQuantityLeft = () => {
        let qty = quantity;
        if (qty > 1) setQuantity(qty - 1);
    }
    const clickQuantityRight = () => {
        let qty = quantity;
        setQuantity(qty + 1);
    }
    const handleBuynow = (e) => {

        let index = e.target.value;
        // console.log("MerchandiseID: "+itemList[index].id);

        shopService.checkStock(itemList[index].id, selectedList)
            .then((response) => {

                // console.log(response);

                let data = response.body.size;
                let itemID = response.body.merchandiseID;
                let temp = [];
                let selectedTemp = [];
                let stock = 0;

                selectedList.forEach((item, index) => {

                });

                if ('stock' in data) {
                    setShowSize(false);
                } else {
                    setShowSize(true);
                    sizeList.forEach((size, index) => {
                        stock = data[size];
                        temp[index] = stock > 0 ? '' : 'disabled';
                    });
                }

                setSizeBtnType(temp);
                setModalEdit(false);
                setModalErrorMessage('');
                setSelectedItem(index);
                setItemID(itemList[index].id);
                setImageView(itemList[index].image1);
                setImage1(itemList[index].image1);
                // setImage2(itemList[index].image2);
                setMerchandiseType(itemList[index].type);
                setGender('');
                if (itemList[index].type === 2) {
                    setSize('stock');
                } else {
                    setSize('');
                }
                setQuantity(1);
                setModalShow(true);

            })
            .catch((error) => {
                console.log(error);
            })

    }



    const handleAddCart = () => { // Add item to cart
        if (size === '' && merchandiseType !== 2) // if size is not selected and the item is not a cap
        {
            setModalErrorMessage('Please make sure size is selected!');
        }
        else {
            let hasRepeated = false;
            let newQty = 0;
            let newSelectedList = [...selectedList];

            selectedList.map((item, index) => {
                if (item.itemID == itemID && item.size == size) {
                    hasRepeated = true;
                    newQty = item.quantity + quantity;
                    newSelectedList[index].quantity = newQty;
                }
            });

            if (!hasRepeated) {
                let obj = {
                    item: selectedItem,
                    itemID: itemID,
                    gender: gender,
                    size: size,
                    quantity: quantity
                };
                newSelectedList.push(obj);
            }

            shopService.checkStockValidity(newSelectedList, itemID, size)
                .then((response) => {
                    // console.log(response);
                    if (response.status) {
                        setSelectedList(response.body.newSelectedList);
                        setModalShow(false);
                    } else {
                        let size = response.body.size;
                        let stockLeft = response.body.stockLeft;
                        setModalErrorMessage("Size " + size + " only has " + stockLeft + " left.");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });

        }
    }
    const handleCartItemRemove = (index) => { // Remove item from cart
        let arr = [...selectedList];
        if (index !== -1) {
            arr.splice(index, 1);
            setSelectedList(arr);
        }
    }
    const handleCartEditBtn = (index) => { // Edit item from cart
        setEditItem(index);
        setModalEdit(true);

        setModalErrorMessage('');
        setSelectedItem(selectedList[index].item);
        setItemID(itemList[selectedList[index].item].id);
        setImageView(itemList[selectedList[index].item].image1);
        setImage1(itemList[selectedList[index].item].image1);
        setImage2(itemList[selectedList[index].item].image2);
        setGender(selectedList[index].gender);
        setSize(selectedList[index].size);
        setQuantity(selectedList[index].quantity);
        setModalShow(true);
    }
    const handleCartEdit = () => {
        // if(gender === '' && size === '')
        // {
        //     setModalErrorMessage('Please make sure gender and size are selected!');
        // }
        // else if(gender === '')
        // {
        //     setModalErrorMessage('Please make sure gender is selected!');
        // }
        // else if(size === '')
        // {
        //     setModalErrorMessage('Please make sure size is selected!');
        // }
        // else
        // {
        //     let newSelectedList = [...selectedList];
        //     newSelectedList[editItem] = {
        //         item : selectedItem,
        //         gender : gender,
        //         size : size,
        //         quantity : quantity
        //     };
        //     setSelectedList(newSelectedList);
        //     setModalEdit(false);
        //     setEditItem(0);
        //     setModalShow(false);
        // }
        if (size === '') {
            setModalErrorMessage('Please make sure size is selected!');
        }
        else {
            let newSelectedList = [...selectedList];
            newSelectedList[editItem] = {
                item: selectedItem,
                itemID: itemID,
                gender: gender,
                size: size,
                quantity: quantity
            };
            setSelectedList(newSelectedList);
            setModalEdit(false);
            setEditItem(0);
            setModalShow(false);
        }
    }
    const handleChooseSize = (values) => {
        // console.log(sizeBtnType[values]);
        if (sizeBtnType[sizeList.indexOf(values)] === '') {
            setSize(values);
        }
    }
    const handleSubmit = () => {

        let paymentID = localStorage.getItem('paymentID') === null ? '' : localStorage.getItem('paymentID');
        let obj = {
            merchandiseCollection: merchandiseCollection,
            deliveryAddress: deliveryAddress,
            deliveryCity: deliveryCity,
            deliveryPostcode: deliveryPostcode,
            deliveryState: deliveryState,
            deliveryCountry: deliveryCountry
        };

        localStorage.setItem('deliveryInfo', JSON.stringify(obj));
        // update the promo code applied
        localStorage.setItem('promoCode', promo);
        // set the current paymentID
        localStorage.setItem('paymentID', paymentID);

        if (merchandiseCollection === "Delivery Service") {
            if (deliveryAddress === "") {
                setErrorMessage("Please add in your delivery Address");
            } else if (deliveryCity === "") {
                setErrorMessage("Please add in your delivery City");
            } else if (deliveryPostcode === "") {
                setErrorMessage("Please add in your delivery Postcode");
            } else if (deliveryState === "") {
                setErrorMessage("Please add in your delivery State");
            } else {
                navigate('/Cart');
            }
        } else {
            navigate('/Cart');
        }


    }
    const handlePromo = (e) => {
        setPromo(e.target.value);
        localStorage.setItem('promoCode', promo);

    }
    const handleDelivery = (e) => {
        var deliveryMethod = e.target.value;
        setMerchandiseCollection(deliveryMethod);
        if (deliveryMethod === 'Self-Collection') {
            localStorage.setItem('deliveryInfo', JSON.stringify(""));
        }
    }

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token === '' || token === null) {
            navigate('/Login');
        }
        else {
            // console.log(token);
            authService.validateAuthToken(token)
                .then((response) => {
                    // console.log(response);
                    if (!response.status) {
                        navigate('/Login');
                    }
                    else if (!login) {
                        let data = response.body.user;
                        setUserID(data.individualID);
                        localStorage.setItem('userID', data.individualID);
                        // console.log(localStorage.getItem('userID'));
                        setLogin(true);

                        setUserName(data.firstname + ' ' + data.lastname);
                        localStorage.setItem('userName', data.firstname + ' ' + data.lastname);

                        setAuthToken(response.body.token);
                        localStorage.setItem('authToken', response.body.token);

                    }
                })
                .catch((error) => {
                    console.log(error);
                    navigate('/Login');
                })
        }

        let paymentID = localStorage.getItem('paymentID') === null ? '' : localStorage.getItem('paymentID');
        // console.log(paymentID);

    }, [authToken]);

    useEffect(() => {

        // // Close for maintenance
        // let today = new Date();
        // let startDate = new Date('2025-07-01T00:00:00');
        // let endDate = new Date('2025-09-11T17:00:00');

        // if(today.getTime() < startDate.getTime() || today.getTime() > endDate.getTime())
        // {
        //     alert('Shop closed!');
        //     navigate('/Register');
        // }



        if (itemList.length == 0) {
            shopService.getMerchandiseInfo()
                .then((response) => {

                    // console.log(response);

                    let merchandise = response.body.merchandise;
                    let newMerchandise = [];

                    merchandise.map((values, index) => {
                        if (values.hasStock) {
                            let image = JSON.parse(values.imageURL);
                            let item = {
                                id: values.autoID,
                                name: values.product_name,
                                image1: image[0],
                                price: parseFloat(values.price),
                                description: values.description,
                                type: parseInt(values.type),
                            }

                            newMerchandise.push(item);
                        }

                    });

                    console.log(newMerchandise);
                    setItemList(newMerchandise);

                })
                .catch((error) => {
                    console.log(error);
                });
        }


        let obj = {
            merchandiseCollection: 'Self-Collection',
            deliveryAddress: '',
            deliveryCity: '',
            deliveryPostcode: '',
            deliveryState: '',
            deliveryCountry: 'Malaysia'
        };
        let newDelieveryInfo = localStorage.getItem('deliveryInfo') === null ? obj : JSON.parse(localStorage.getItem('deliveryInfo'));
        setMerchandiseCollection(newDelieveryInfo.merchandiseCollection);
        setDeliveryAddress(newDelieveryInfo.deliveryAddress);
        setDeliveryCity(newDelieveryInfo.deliveryCity);
        setDeliveryCountry(newDelieveryInfo.deliveryCountry);
        setDeliveryPostcode(newDelieveryInfo.deliveryPostcode);
        setDeliveryState(newDelieveryInfo.deliveryState);

        let newSelectedList = localStorage.getItem('selectedList') === null ? [] : JSON.parse(localStorage.getItem('selectedList'));
        setSelectedList(newSelectedList);

        let currentDate = new Date();
        let monthsOfYear = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        let month = monthsOfYear[currentDate.getMonth()];
        let day = currentDate.getDate();
        let year = currentDate.getFullYear();

        let formattedDate = `${day} ${month} ${year}`;
        setDate(formattedDate);

    }, []);

    // use to control the error message in modal
    useEffect(() => {
        if (modalErrorMessage !== '') {
            // if(gender === '' && size === '')
            // {
            //     setModalErrorMessage('Please make sure gender and size are selected!');
            // }
            // else if(gender === '')
            // {
            //     setModalErrorMessage('Please make sure gender is selected!');
            // }
            // else if(size === '')
            // {
            //     setModalErrorMessage('Please make sure size is selected!');
            // }
            // else
            // {
            //     setModalErrorMessage('');
            // }
            if (size === '') {
                setModalErrorMessage('Please make sure size is selected!');
            }
            else {
                setModalErrorMessage('');
            }
        }
    }, [gender, size]);

    // Calculate the total amount whenever item list is updated
    useEffect(() => {

        // console.log(selectedList);

        let amount = 0;
        let qty = 0;
        itemList.length > 0 && selectedList.map((values) => {
            // console.log(values);
            qty += values.quantity;
            amount += itemList[values.item].price * values.quantity;
            if (merchandiseCollection === "Delivery Service") {
                amount += deliveryFee * values.quantity;
            }
        });

        localStorage.setItem('selectedList', JSON.stringify(selectedList));

        setSelectedQuantity(qty);
        setTotal(amount);

        // console.log('Total = ' + amount);

    }, [itemList, selectedList, merchandiseCollection]);






    return (
        <Container fluid="lg" className='wrapper'>
            <h1 className="title">Merchandise</h1>

            {/* <RegBreadcrumb page={1} />
            <br /> */}

            <Row className="runner-detail mb-5">
                <Col md={8} xs={12} >

                    <Row className='itemList'>
                        {itemList.length > 0 && itemList.map((values, index) => (
                            <Card className="item" key={index}>
                                <Card.Img className='shopItemImg' variant="top" src={`${process.env.PUBLIC_URL}/images/${values.image1}`} />
                                <Card.Body>
                                    <Card.Title className="itemName">{values.name}</Card.Title>
                                    <Card.Text className="itemDesc">
                                        {/* {values.description} */}
                                    </Card.Text>
                                    <Card.Subtitle className="mb-2 itemPrice">RM {values.price.toFixed(2)}</Card.Subtitle>
                                    <Button className="red-button form-control" value={index} onClick={handleBuynow}>Buy Now</Button>
                                </Card.Body>
                            </Card>
                        ))}
                        {itemList.length === 0 && (
                            <p>
                                No merchandise has been added yet.
                            </p>
                        )}
                    </Row>

                </Col>
                <Col md={4} xs={12} >
                    <div id="regChart">

                        <Row className="chartTitle">
                            <Stack direction="horizontal" gap={2}>
                                <h5 className="me-auto"><FontAwesomeIcon icon={faCartShopping} />&nbsp;&nbsp;My Cart</h5>
                                <span className="text-muted">{date}</span>
                            </Stack>
                        </Row>

                        <hr />

                        <div className="chartItemBox">
                            <ul className="chartItemList">
                                {itemList.length > 0 && selectedList.length > 0 && selectedList.map((values, index) => (
                                    <li key={index}>
                                        <div className="subChartTitle">
                                            <h6>{itemList[values.item].name}</h6>
                                        </div>
                                        <div className="subChartDetail">
                                            {/* <p className='subCartItemDetail'>{values.gender + ', ' + values.size + ' - RM' + itemList[values.item].price.toFixed(2)}</p> */}
                                            <p className='subCartItemDetail'>{values.size + ' - RM' + itemList[values.item].price.toFixed(2)}</p>
                                            <p className='subCartItemQuantity'>x{values.quantity}</p>
                                            <p className='subCartItemAction'>
                                                <a href="#" onClick={() => handleCartEditBtn(index)}>Edit</a> | <a href="#" onClick={() => handleCartItemRemove(index)}>Remove</a>
                                            </p>
                                            <p className='subCartItemTotal'>RM <span>{(values.quantity * itemList[values.item].price).toFixed(2)}</span></p>
                                        </div>
                                    </li>
                                ))}
                                {selectedList.length > 0 && merchandiseCollection === "Delivery Service" && (
                                    <li>
                                        <div className="subChartDetail">
                                            <p className='subCartItemDetail'>Delivery Service x{selectedQuantity}</p>
                                            {/* <p className='subCartItemQuantity'>x{values.quantity}</p> */}
                                            <p className='subCartItemTotal'>RM <span>{(Math.round((selectedQuantity * deliveryFee) * 100) / 100).toFixed(2)}</span></p>
                                        </div>
                                    </li>
                                )}
                                {selectedList.length === 0 && (
                                    <li>
                                        No item being selected yet.
                                    </li>
                                )}
                            </ul>
                        </div>

                        <hr />

                        <Row className="promo">
                            <FloatingLabel controlId="deliveryService" label="Collection Type">
                                <Form.Select
                                    aria-label="Default select example"
                                    name="Delevery Service"
                                    onChange={handleDelivery}
                                    value={merchandiseCollection}
                                >
                                    <option style={{ background: '#fff', color: '#777' }} key="Self-Collect" value="Self-Collect">Self Collect</option>
                                    {/* <option style={{background: '#fff', color:'#777'}} key="Delivery Service" value="Delivery Service">Delivery Service</option> */}
                                </Form.Select>
                            </FloatingLabel>
                        </Row>

                        {merchandiseCollection === "Delivery Service" && (
                            <>
                                {/* <Form.Group className="mb-1 mt-2" id="formGridCheckbox">
                                    <Form.Check 
                                    type="checkbox" 
                                    label="Use my address" 
                                    onChange={(e) => {handleIsMyAddress(e, index)}} 
                                    checked={isMyAddress[index]} 
                                    />
                                </Form.Group> */}

                                <hr />

                                <Row className="promo">

                                    <h5>Delivery Address</h5>

                                    <FloatingLabel className="mb-3" controlId={`deliveryAddress`} label="Address">
                                        <Form.Control
                                            required
                                            as="textarea"
                                            placeholder="Address"
                                            style={{ height: '100px', color: '#555' }}
                                            name={`deliveryAddress`}
                                            onChange={(e) => { setDeliveryAddress(e.target.value) }}
                                            value={deliveryAddress}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel className="mb-3" controlId={`deliveryPostcode`} label="Postcode">
                                        <Form.Control
                                            required
                                            name={`deliveryPostcode`}
                                            type="text"
                                            placeholder="Postcode"
                                            onChange={(e) => { setDeliveryPostcode(e.target.value) }}
                                            value={deliveryPostcode}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel className="mb-3" controlId={`deliveryCity`} label="City">
                                        <Form.Control
                                            required
                                            name={`deliveryCity`}
                                            type="text"
                                            placeholder="City"
                                            onChange={(e) => { setDeliveryCity(e.target.value) }}
                                            value={deliveryCity}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel className="mb-3" controlId={`deliveryState`} label="State">
                                        <Form.Control
                                            required
                                            name={`deliveryState`}
                                            type="text"
                                            placeholder="Last name"
                                            onChange={(e) => { setDeliveryState(e.target.value) }}
                                            value={deliveryState}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel className="mb-3" controlId={`deliveryCountry`} label="Country">
                                        <Form.Select
                                            aria-label="Default select example"
                                            name={`deliveryCountry`}
                                            onChange={(e) => { setDeliveryCountry(e.target.value) }}
                                            value={deliveryCountry}
                                        >
                                            {/* <option key="" value="">Select a country</option> */}
                                            <option key="Malaysia" value="Malaysia">Malaysia</option>
                                            {/* <option key="Singapore" value="Singapore">Singapore</option> */}
                                            {/* <option key="Brunei" value="Brunei">Brunei</option> */}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Row>
                            </>
                        )}

                        <hr />

                        <Row className="promo">
                            <FloatingLabel controlId="floatingPromo" label="Promo Code">
                                <Form.Control type="text" placeholder="Promo Code" onChange={handlePromo} />
                            </FloatingLabel>
                        </Row>

                        <hr />

                        {errorMessage !== "" && (
                            <Col md={12} xs={12}>
                                <Alert variant="danger" className='m-3'>
                                    {errorMessage}
                                </Alert>
                            </Col>
                        )}

                        <Row className="chartTotal chartItemList">
                            <div className="chartTotal subChartDetail">
                                <p className='chartTotalLeft subChartDetailLeft'>Total</p>
                                <p className='chartTotalRight subChartDetailRight'>RM <span>{total.toFixed(2)}</span></p>
                            </div>
                            <Col>
                                <Button type="submit" className="btn red-button form-control" onClick={handleSubmit}>Proceed</Button>
                            </Col>
                        </Row>

                    </div>
                </Col>
            </Row>

            <Modal
                className="itemDetail"
                size="lg"
                centered
                show={modalShow}
                fullscreen={fullscreen}
            >
                {/* <Modal.Header closeButton>
                </Modal.Header> */}
                <Modal.Body>
                    <button className="modal-close" onClick={() => setModalShow(false)}>&times;</button>
                    <Row>
                        <Col lg={5} md={12} xs={12} className="text-center">
                            <Figure>
                                <Figure.Image
                                    id="modal-image"
                                    alt="Image 1"
                                    src={`${process.env.PUBLIC_URL}/images/${imageView}`}
                                />
                                {/* <Figure.Caption className="img-btn-holder">
                                    <div className={imageBoxActive ? 'img-btn active':'img-btn '}  onClick={() => setImageBoxActive(true)}>
                                        <img id="left-img" src={`${process.env.PUBLIC_URL}/images/${image1}`} alt="Image 1" />
                                    </div>
                                    <div className={imageBoxActive ? 'img-btn ':'img-btn active'}  onClick={() => setImageBoxActive(false)}>
                                        <img id="right-img" src={`${process.env.PUBLIC_URL}/images/${image2}`} alt="Image 2" />
                                    </div>
                                </Figure.Caption> */}
                            </Figure>
                        </Col>
                        <Col lg={7} md={12} xs={12}>
                            {/* <h3 id="itemName">{modalEdit ? itemList[selectedItem].name : ''}</h3> */}
                            {/* <p id="itemDesc">{modalEdit ? itemList[selectedItem].description : ''}</p> */}
                            {/* <h4 id="itemPrice">RM <span>{modalEdit ? itemList[selectedItem].price.toFixed(2) : '0.00'}</span></h4> */}
                            <h3 id="itemName">{itemList.length > 0 ? itemList[selectedItem].name : ''}</h3>
                            <p id="itemDesc">{itemList.length > 0 ? itemList[selectedItem].description : ''}</p>
                            <h4 id="itemPrice">RM <span>{itemList.length > 0 ? itemList[selectedItem].price.toFixed(2) : '0.00'}</span></h4>

                            <br />

                            {/* <Row id="radios">
                                <div className="d-flex align-items-center">
                                    <h5 className="align-items-center">Gender : </h5>
                                    <div className="d-flex flex-wrap">
                                        <div className={gender==='Male' ? 'round-check active':'round-check'} onClick={() => setGender('Male')} >
                                            <span><FontAwesomeIcon icon={faPerson} /></span>
                                        </div>								
                                        <div className={gender==='Female' ? 'round-check active':'round-check'} onClick={() => setGender('Female')} >
                                            <span><FontAwesomeIcon icon={faPersonDress} /></span>
                                        </div>
                                    </div>
                                </div>
                            </Row> */}

                            {/* <br /> */}


                            {showSize && (
                                <Row id="radios" >
                                    <div className="d-flex align-items-center">
                                        <h5 className="align-items-center">Size : </h5>
                                        <div className="d-flex flex-wrap">
                                            {sizeList.map((values, index) => (
                                                <div key={index} className={size === values ? 'round-check active ' + sizeBtnType[index] : 'round-check ' + sizeBtnType[index]} onClick={() => handleChooseSize(values)} >
                                                    <span>{values}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Row>
                            )}


                            <Row id="radios">
                                <div className="d-flex align-items-center">
                                    <h5 className="align-items-center">Quantity : </h5>
                                    <InputGroup className='shop'>
                                        <Button
                                            variant="outline-secondary"
                                            id="button-addon1"
                                            className="btn-left"
                                            onClick={clickQuantityLeft}
                                        >
                                            &#45;
                                        </Button>
                                        <Form.Control
                                            placeholder=""
                                            aria-label=""
                                            aria-describedby="basic-addon2"
                                            value={quantity}
                                            onChange={handleQuantity}
                                            type="number"
                                        // disabled
                                        />
                                        <Button
                                            variant="outline-secondary"
                                            id="button-addon2"
                                            className="btn-right"
                                            onClick={clickQuantityRight}
                                        >
                                            &#43;
                                        </Button>
                                    </InputGroup>
                                </div>
                            </Row>

                            {modalErrorMessage !== '' && (
                                <Row className="mt-2">
                                    <Alert variant="danger">
                                        {modalErrorMessage}
                                    </Alert>
                                </Row>
                            )}

                            <Row className="mt-4">
                                {modalEdit ? (
                                    <Stack direction="horizontal" gap={3}>
                                        <Button className="btn-secondary btn ms-auto" onClick={() => setModalShow(false)}>Cancel</Button>
                                        <Button className="btn-secondary btn" onClick={() => handleCartItemRemove(editItem)}>Delete</Button>
                                        <Button className="red-button btn" onClick={() => handleCartEdit(editItem)}>Update</Button>
                                    </Stack>
                                ) : (
                                    <Stack direction="horizontal" gap={2}>
                                        <Button className="btn-secondary btn ms-auto" onClick={() => setModalShow(false)}>Cancel</Button>
                                        <Button className="red-button btn" onClick={handleAddCart}>Add to Cart</Button>
                                    </Stack>
                                )}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

        </Container>
    );
}

export default Shop;